import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import moment from "moment";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  validaEmail,
} from "../../util/varios";
import axios from "axios";
import CatalogoResponExpendio from "../../catalogos/catalogoRspnExp";
import { ClaveSupervisor } from "../configuracionGeneral/modalClaveSupervisor";

export const GestionarFiscales = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const deshabilitado = false;

  const txtCedula = useRef();
  const txtNombreRespon = useRef();
  const txtObserStatus = useRef();
  const txtDireccionRespon = useRef();
  const txtMonto = useRef();
  const txtCedulaPro = useRef();
  const txtNombrePro = useRef();
  const txtNumPro = useRef();
  const txtDireccionPro = useRef();
  const chkIn = useRef();
  const chkIn1 = useRef();
  const txtSucursal = useRef();
  const chkIn2 = useRef();
  const txtId = useRef();
  const txtLicencia = useRef();
  const txtResolucion = useRef();
  const txtFechaIns = useRef();
  const chkConvenio = useRef();
  const cmbSex = useRef();
  const txtTipoNac = useRef();
  const txtApeRespon = useRef();
  const txtEmail = useRef();
  const txtEmailr = useRef();
  const txtFechNac = useRef();
  const txtStatus = useRef();
  const cmbNacionalidad = useRef();
  const txtTlf1 = useRef();
  const txtTlf2 = useRef();
  const txtCiudad = useRef();
  const txtMunicipio = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [nacnalidad, setNacnalidad] = useState("");
  const [activate, setActivate] = useState(false);
  const [fechas, setFechas] = useState(0.0);
  const [values, setValues] = useState({
    idagente: "",
    nombre: "",
    direccion: "",
    rif: "",
    nrolicenciafiscal: "",
    nroresolucionfiscal: "",
    reprelegal: "",
    telefono: "",
    fechainscripcionfiscal: "",
    statusfiscal: "",
    idtipoagente: "",
    observacionstatusfiscal: null,
    credito: 0.0,
    email: "",
    exoninteresesfiscal: false,
    exonmultasfiscal: false,
    exonrecargosfiscal: false,
    ciudad: null,
    municipio: null,
    conveniofiscal: false,
    fiscal: false,
  });
  const [editarRif, setEditarRif] = useState(true);
  const [mostrar2, setMostrar2] = useState(false);
  const [body, setBody] = useState(null);
  const [operacion, setOperacion] = useState(0);
  const [visibleF, setVisibleF] = useState("hidden");
  const [catalogo, setCatalogo] = useState(false);
  const [tecla, setTecla] = useState();
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacionPer, setOperacionPer] = useState(0);
  const [municipios, setMunicipios] = useState();
  const [ciudades, setCiudades] = useState();

  const onChange = (event) => {
    if (
      event.target.name === "nombre" ||
      event.target.name === "direccionage" ||
      event.target.name === "email" ||
      event.target.name === "nombrerespo" ||
      event.target.name === "aperespo" ||
      event.target.name === "propiEmail" ||
      event.target.name === "licencia" ||
      event.target.name === "resolucion"
    ) {
      event.target.value = event.target.value.toUpperCase();
      setValues({
        ...values,
        [event.target.name]: event.target.value.toUpperCase(),
      });
    } else if (event.target.name === "exoninteresesfiscal") {
      setValues({ ...values, [event.target.name]: event.target.checked });
    } else if (event.target.name === "exonmultasfiscal") {
      setValues({ ...values, [event.target.name]: event.target.checked });
    } else if (event.target.name === "exonrecargosfiscal") {
      setValues({ ...values, [event.target.name]: event.target.checked });
    } else if (event.target.name === "conveniofiscal") {
      setValues({ ...values, [event.target.name]: event.target.checked });
    } else if (event.target.name === "statusfiscal") {
      if (event.target.value === "52") {
        if (visibleF === "hidden") {
          setVisibleF("visible");
        } else {
          setVisibleF("hidden");
        }
      } else {
        setVisibleF("hidden");
        txtObserStatus.current.value = "";
      }
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "municipio") {
      selectCiudad(event.target.value);
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "nac") {
      let nac = txtTipoNac.current.value;
      // txtCedulaPro.current.value = "";
      txtCedulaPro.current.focus();
      setNacnalidad(nac);
    } else if (event.target.name === "rif") {
      validaSoloNumero(event);
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };

  const onFecha = () => {
    let tfechas;
    let fecha = parseInt(fechaSistema.substring(1, 5));
    let mes = parseInt(fechaSistema.substring(6, 8));
    let dia = parseInt(fechaSistema.substring(9, 11));
    tfechas = fecha - 18;
    setFechas(tfechas + "-" + 0 + mes + "-" + dia);
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.which === 13) {
        if (event.target.id === "credito") {
          txtMonto.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    var valido;
    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtStatus.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar un Estatus",
        icono: "informacion",
      });
      sigue = false;
      txtStatus.current.focus();
    } else if (txtTipoNac.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Tipo de Nacionalidad",
        icono: "informacion",
      });
      txtTipoNac.current.focus();
      sigue = false;
    } else if (txtCedulaPro.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por Favor Introdusca la Cedula o Rif del Contribuyente/Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtCedulaPro.current.focus();
    } else if (txtNombrePro.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa el Nombre del Contribuyente u Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtNombrePro.current.focus();
    } else if (txtDireccionPro.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Dirección del Contribuyente/Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtDireccionPro.current.focus();
    } else if (txtNumPro.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el contacto del Contribuyente/Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtNumPro.current.focus();
    } else if (txtEmail.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Correo del Contribuyente/Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtEmail.current.focus();
    } else if (!validaEmail(txtEmail.current.value.trim())) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Formato del E-Mail no es Valido",
        icono: "informacion",
      });

      txtEmail.current.focus();
    } else if (operacion === 1 && cmbNacionalidad.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por favor Seleccione la Nacionalidad",
        icono: "informacion",
      });
      sigue = false;
      cmbNacionalidad.current.focus();
    } else if (operacion === 1 && cmbSex.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por favor Seleccione el Sexo del Representante Legal",
        icono: "informacion",
      });
      sigue = false;
      cmbSex.current.focus();
    } else if (operacion === 1 && txtCedula.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por favor Seleccione el Representante Legal",
        icono: "informacion",
      });
      sigue = false;
      txtCedula.current.focus();
    } else if (operacion === 1 && txtNombreRespon.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Nombre del Representante Legal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtNombreRespon.current.focus();
    } else if (operacion === 1 && txtApeRespon.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Apellido del Representante Legal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtApeRespon.current.focus();
    } else if (
      operacion === 1 &&
      txtDireccionRespon.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Dirección del Representante Legal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDireccionRespon.current.focus();
    } else if (operacion === 1 && txtEmailr.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El E-mail del Representante Legal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtEmailr.current.focus();
    } else if (
      operacion === 1 &&
      !validaEmail(txtEmailr.current.value.trim())
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Formato del E-Mail no es Valido",
        icono: "informacion",
      });

      txtEmailr.current.focus();
      sigue = false;
    } else if (operacion === 1 && txtFechNac.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "La Fecha de Nacimiento del Representante Legal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtFechNac.current.focus();
    } else if (operacion === 1 && txtTlf1.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "Por Favor Introdusca el Número de Contacto del Respresentante Legal",
        icono: "informacion",
      });
      sigue = false;
      txtTlf1.current.focus();
    } else if (operacion === 1 && txtTlf2.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "Por Favor Introdusca el Número de Contacto del Respresentante Legal",
        icono: "informacion",
      });
      sigue = false;
      txtTlf2.current.focus();
    } else if (txtFechaIns.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha de Inscripción no debe ir Vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFechaIns.current.focus();
    } else if (txtLicencia.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el N° de licencia",
        icono: "informacion",
      });
      sigue = false;
      txtLicencia.current.focus();
    } else if (txtResolucion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el N° de Resolucion",
        icono: "informacion",
      });
      sigue = false;
      txtResolucion.current.focus();
    } else if (sigue) {
      var agente = [];
      var repre = [];

      agente.push({
        idagente: txtId.current.value === "" ? 0 : txtId.current.value,
        nombre: txtNombrePro.current.value.trim(),
        direccion: txtDireccionPro.current.value.trim(),
        rif: nacnalidad + txtCedulaPro.current.value,
        nrolicenciafiscal: txtLicencia.current.value.trim(),
        nroresolucionfiscal: txtResolucion.current.value.trim(),
        reprelegal: txtCedula.current.value.trim(),
        telefono: txtNumPro.current.value.trim(),
        fechainscripcionfiscal: txtFechaIns.current.value.trim(),
        statusfiscal: txtStatus.current.value.trim(),
        idtipoagente: 5,
        fiscal: props.operacion === 3 ? false : true,
        observacionstatusfiscal: txtObserStatus.current.value.trim(),
        credito: parseFloat(
          txtMonto.current.value.trim().replace(/\./g, "").replace(",", ".")
        ),
        email: txtEmail.current.value,
        exoninteresesfiscal: chkIn.current.checked ? true : false,
        exonmultasfiscal: chkIn1.current.checked ? true : false,
        exonrecargosfiscal: chkIn2.current.checked ? true : false,
        ciudad: txtCiudad.current.value.trim(),
        municipio: txtMunicipio.current.value.trim(),
        sucursal: txtSucursal.current.value.trim(),
        conveniofiscal: chkConvenio.current.checked ? true : false,
      });
      repre.push({
        cedula: parseInt(txtCedula.current.value),
        correoe: txtEmailr.current.value,
        tlf1: txtTlf1.current.value,
        tlf2: txtTlf2.current.value,
        apellidos: txtApeRespon.current.value,
        direccion: txtDireccionRespon.current.value,
        fnacimiento: txtFechNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreRespon.current.value,
        sexo: cmbSex.current.value,
      });
      setBody({
        operacionper: operacionPer,
        agente: agente,
        repre: repre,
        clases: [],
        operacioncontri: 0,
      });
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);

    let endpoint = "";

    if (operacion === 3) {
      endpoint = `${op.conexion}/api/agente/actualizaragente/2`;
    } else {
      endpoint = `${op.conexion}/api/agente/actualizaragente/${parseInt(
        operacion
      )}`;
    }
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            "llave duplicada viola restricción de unicidad «agente_rif_key»"
          ) {
            mensaje = "Ya existe un Registro con este Rif y Sucursal";
          } else if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_email_key"'
          ) {
            mensaje = "Ya existe un Registro con este correo";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const aceptaClaveSupervisor = () => {
    setMostrar2(false);
    setEditarRif(!editarRif);
    setOperacion(2);
  };

  const cancelaClaveSupervisor = () => {
    setMostrar2(false);
  };

  const blanquear = () => {
    setActivate(false);
    setVisibleF("hidden");
    setCiudades([]);
    setEditarRif(true);
    txtCedula.current.value = "";
    txtNombreRespon.current.value = "";
    txtApeRespon.current.value = "";
    txtDireccionRespon.current.value = "";
    txtEmail.current.value = "";
    txtEmailr.current.value = "";
    txtFechNac.current.value = "";
    txtTlf1.current.value = "";
    txtTlf2.current.value = "";
    cmbNacionalidad.current.value = "";
    cmbSex.current.value = "";
    txtFechaIns.current.value = moment(fechaSistema).format("YYYY-MM-DD");
    chkIn.current.checked = false;
    chkIn2.current.checked = false;
    chkIn1.current.checked = false;
    chkConvenio.current.checked = false;
    txtMonto.current.value = "0,00";
    txtLicencia.current.value = "";
    txtResolucion.current.value = "";
    setValues({
      idagente: "",
      nombre: "",
      direccion: "",
      rif: "",
      nrolicenciafiscal: "",
      nroresolucionfiscal: "",
      reprelegal: "",
      telefono: "",
      fechainscripcionfiscal: "",
      statusfiscal: "",
      idtipoagente: "",
      observacionstatusfiscal: null,
      credito: 0.0,
      email: "",
      exoninteresesfiscal: false,
      exonmultasfiscal: false,
      exonrecargosfiscal: false,
      ciudad: null,
      municipio: null,
      conveniofiscal: false,
      fiscal: false,
    });

    setOperacion(props.operacion);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const handleCatalogo = () => {
    if (!catalogo) {
      setCatalogo(true);
    } else {
      setCatalogo(false);
    }
  };

  const handleAceptaCatalogoPer = (
    ced,
    corr,
    tlf1,
    tlf2,
    ape,
    direc,
    fcn,
    nac,
    nom,
    sex
  ) => {
    setCatalogo(false);
    setHabilitadoNU(false);

    txtCedula.current.value = ced;
    txtNombreRespon.current.value = nom !== null ? nom.trim() : "";
    txtApeRespon.current.value = ape !== null ? ape.trim() : "";
    txtDireccionRespon.current.value = direc !== null ? direc : "";
    txtEmailr.current.value = corr !== null ? corr.trim() : "";
    txtFechNac.current.value =
      fcn !== null ? moment(fcn).format("YYYY-MM-DD") : "";
    txtTlf1.current.value = tlf1 !== null ? tlf1.trim() : "";
    txtTlf2.current.value = tlf2 !== null ? tlf2.trim() : "";
    cmbNacionalidad.current.value = nac !== null ? nac.toString().trim() : "";
    cmbSex.current.value = sex !== null ? sex.toString().trim() : "";
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreRespon.current.value = "";
      }
    }
  };

  const validarPropie = (event) => {
    //event.preventDefault();

    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        txtCedulaPro.current.value !== "" &&
        txtSucursal.current.value !== "" &&
        txtTipoNac.current.value !== ""
      ) {
        datosPro(
          nacnalidad + txtCedulaPro.current.value,
          txtSucursal.current.value
        );
      }

      if (txtCedulaPro.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Igresar el Rif.",
          icono: "informacion",
        });
        txtCedulaPro.current.focus();
      }
      if (txtSucursal.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Rif.",
          icono: "informacion",
        });
        txtSucursal.current.focus();
      }
      if (txtTipoNac.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar el Literal del Rif.",
          icono: "informacion",
        });
        txtTipoNac.current.focus();
      }
    }
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setHabilitadoNU(true);
          txtNombreRespon.current.value = "";
          txtApeRespon.current.value = "";
          txtDireccionRespon.current.value = "";
          txtEmailr.current.value = "";
          txtFechNac.current.value = "";
          txtTlf1.current.value = "";
          txtTlf2.current.value = "";
          cmbNacionalidad.current.value = "";
          cmbSex.current.value = "";
          if (response.data !== "") {
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSex.current.value = response.data.sexo;
            txtNombreRespon.current.value = response.data.nombres;
            txtApeRespon.current.value = response.data.apellidos;
            txtDireccionRespon.current.value = response.data.direccion;
            txtEmailr.current.value = response.data.correoe;
            txtTlf1.current.value = response.data.tlf1;
            txtTlf2.current.value = response.data.tlf2;
            txtFechNac.current.value = moment(response.data.fnacimiento).format(
              "YYYY-MM-DD"
            );

            setHabilitadoNU(false);
            setOperacionPer(0);

            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreRespon.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const datosPro = (rif, sur) => {
    //  let endpoint = `${op.conexion}/api/consulta/seleccionarPro?id=${rif}&id2=${sur}`;
    setActivate(true);

    let campos = "*";
    let nomtab = "agente";
    let nomid = `rif`;
    let nomid2 = `sucursal`;
    let id = rif;
    let id2 = sur;
    let orden = "idagente";
    let endpoint = `${op.conexion}/api/consulta/idsstring2?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            if (
              parseInt(response.data.statusfiscal) === 51 ||
              response.data.statusfiscal === null
            ) {
              setVisibleF("hidden");
            } else {
              setVisibleF("visible");
            }
            selectCiudad(
              response.data.municipio.trim(),
              response.data.ciudad.trim()
            );
            if (response.data.reprelegal !== "") {
              datosRes(parseInt(response.data.reprelegal));
              txtCedula.current.value = response.data.reprelegal.trim();
            }

            setOperacion(2);
            txtStatus.current.value = response.data.statusfiscal;
            //txtCedulaPro.current.value = response.data.rif;
            txtNombrePro.current.value = response.data.nombre;
            txtDireccionPro.current.value = response.data.direccion;
            txtNumPro.current.value = response.data.telefono;
            txtMonto.current.value = formatMoneda(
              response.data.credito
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtLicencia.current.value = response.data.nrolicenciafiscal;
            txtResolucion.current.value = response.data.nroresolucionfiscal;
            txtEmail.current.value = response.data.email;
            setValues(response.data);

            btnAcepta.current.focus();
          } else {
            if (editarRif) {
              setOperacion(1);
            }

            selectMunicipio();
            // blanquear();

            setTimeout(() => {
              txtNombrePro.current.focus();
            }, 100);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectMunicipio = () => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let id = "18";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMunicipios(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectCiudad = (idm, idc) => {
    if (idm !== "") {
      let campos = "*";
      let nomtab = "ciudad";
      let nomid = "idmunicipio";

      let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idm}&nomtab=${nomtab}&nomid=${nomid}`;

      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            setCiudades(response.data);

            txtMunicipio.current.value = idm;

            txtCiudad.current.value = idc;
          }
        })
        .catch(function (error) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: error.response.data.message,
            icono: "error",
          });
        });
    } else {
      setCiudades("");
    }
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const llenarCampos = () => {
    onFecha();
    selectMunicipio();
    btnAcepta.current.focus();
    setOperacion(props.operacion);
    if (props.operacion !== 1) {
      setValues(props.expendedor);
      selectCiudad(props.expendedor.municipio, props.expendedor.ciudad);
      setNacnalidad(props.expendedor.rif.substring(0, 1));

      if (props.expendedor.statusfiscal === "52") {
        setVisibleF("visible");
      } else {
        setVisibleF("hidden");
      }
    } else {
      setVisibleF("hidden");
      txtTipoNac.current.value = "";
      txtCedulaPro.current.value = "";
      txtCedula.current.value = "";
      txtNombreRespon.current.value = "";
      txtApeRespon.current.value = "";
      txtDireccionRespon.current.value = "";
      txtEmail.current.value = "";
      txtEmailr.current.value = "";
      txtFechNac.current.value = "";
      txtTlf1.current.value = "";
      txtTlf2.current.value = "";
      cmbNacionalidad.current.value = "";
      cmbSex.current.value = "";
      chkIn.current.checked = false;
      chkIn2.current.checked = false;
      chkIn1.current.checked = false;
      chkConvenio.current.checked = false;
      txtFechaIns.current.value = moment(
        JSON.parse(localStorage.getItem("fechasistema"))
      ).format("YYYY-MM-DD");
      setValues({
        idagente: "",
        nombre: "",
        direccion: "",
        rif: "",
        nrolicenciafiscal: "",
        nroresolucionfiscal: "",
        reprelegal: "",
        telefono: "",
        fechainscripcionfiscal: "",
        statusfiscal: "",
        idtipoagente: "",
        observacionstatusfiscal: null,
        credito: 0.0,
        email: "",
        exoninteresesfiscal: false,
        exonmultasfiscal: false,
        exonrecargosfiscal: false,
        ciudad: null,
        municipio: null,
        conveniofiscal: false,
        fiscal: false,
      });
    }
  };

  const editar = () => {
    setMostrar2(true);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={llenarCampos}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>
          {props.operacion === 1
            ? "Agregar Fiscal."
            : props.operacion === 2
            ? "Editar Fiscal."
            : props.operacion === 3
            ? "Eliminar Fiscal."
            : "Consultar Fiscal."}
        </Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <CatalogoResponExpendio
          show={catalogo}
          onHideCancelaCatPer={handleCatalogo}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />
        <ClaveSupervisor
          show={mostrar2}
          onHideCancelaSup={cancelaClaveSupervisor}
          onHideAceptaSup={aceptaClaveSupervisor}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div style={{ height: "auto", overflow: "auto" }}>
          <div style={{ fontFamily: "Times New Roman, Times, serif" }}>
            <div className="row rounded mx-auto">
              <div className=" py-3 row d-flex justify-content-between col-md-12 py-2 ">
                <div className="input-group input-group-sm col-sm-2">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Código:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled={true}
                    name="idagente"
                    ref={txtId}
                    value={values.idagente}
                  />
                </div>

                <div className="input-group input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Fecha de Inscripción:
                  </label>
                  <input
                    type="date"
                    autoComplete="off"
                    max={moment(fechaSistema).format("YYYY-MM-DD")}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled={
                      operacion === 1 || operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    ref={txtFechaIns}
                    name="fechainscripcionfiscal"
                    defaultValue={
                      props.expendedor
                        ? props.expendedor.fechainscripcionfiscal !== null
                          ? moment(
                              props.expendedor.fechainscripcionfiscal
                            ).format("YYYY-MM-DD")
                          : ""
                        : moment(fechaSistema).format("YYYY-MM-DD")
                    }
                    onChange={onChange}
                    id="inputFechaInscripcion"
                  />
                </div>

                <div className="input-group input-group-sm col-sm-2">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Estatus:
                  </label>
                  <select
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    ref={txtStatus}
                    autoComplete="off"
                    className="form-select text-center"
                    id="inputStatus"
                    name="statusfiscal"
                    value={values.statusfiscal}
                    onChange={onChange}
                  >
                    <option value="">seleccione</option>
                    <option value="51">ACTIVO</option>
                    <option value="52">INACTIVO</option>
                  </select>
                </div>

                <div
                  className="input-group input-group-sm col-sm-5"
                  style={{ visibility: visibleF }}
                >
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Observación Estatus:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="observacionstatusfiscal"
                    ref={txtObserStatus}
                    value={values.observacionstatusfiscal}
                    onChange={onChange}
                  />
                </div>
              </div>
              <div className="container rounded row d-flex border justify-content-between mx-auto col-md-12">
                <div className=" col-md-6 row py-3 px-4 justify-content-between ">
                  <div className="col-sm-11 p-0 text-success2">
                    <h4 className="text-success2  titulos">
                      <i className="fas fa-lg px-2 fa-user-edit"></i>Datos del
                      Fiscal
                    </h4>
                    <hr />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-8">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Cédula o RIF:
                    </label>
                    <select
                      disabled={
                        (operacion === 4 ||
                          operacion === 3 ||
                          operacion === 2) &&
                        editarRif
                          ? true
                          : false
                      }
                      ref={txtTipoNac}
                      name="nac"
                      onChange={onChange}
                      defaultValue={
                        props.expendedor && props.expendedor.rif
                          ? props.expendedor.rif.substring(0, 1)
                          : ""
                      }
                      className="col-sm-3 px-2 form-select form-control-sm"
                    >
                      <option value="">-</option>
                      <option key="0" value="V">
                        V
                      </option>
                      <option key="1" value="J">
                        J
                      </option>
                      <option key="2" value="G">
                        G
                      </option>
                      <option key="3" value="P">
                        P
                      </option>
                    </select>
                    <input
                      type="text"
                      className="form-control col-5"
                      autoComplete="off"
                      onKeyUp={validarPropie}
                      onBlur={validarPropie}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtCedulaPro}
                      disabled={
                        (operacion === 4 ||
                          operacion === 3 ||
                          operacion === 2) &&
                        editarRif
                          ? true
                          : false
                      }
                      maxLength="9"
                      defaultValue={
                        props.expendedor && props.expendedor.rif
                          ? props.expendedor.rif.substring(1, 10)
                          : ""
                      }
                      onChange={onChange}
                      id="rif"
                      name="rif"
                    />
                    <button
                      className="btn btn-sm col-sm-2  btn-warning "
                      /* disabled={editarRif}  */ onClick={editar}
                    >
                      <i className="fa fa-edit"></i>{" "}
                    </button>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Sucursal:
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      onKeyUp={validarPropie}
                      onBlur={validarPropie}
                      aria-label="Sizing example input"
                      min={0}
                      autoComplete="off"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtSucursal}
                      disabled={
                        (operacion === 4 ||
                          operacion === 3 ||
                          operacion === 2) &&
                        editarRif
                          ? true
                          : deshabilitado
                      }
                      defaultValue={
                        values.sucursal && values.sucursal ? values.sucursal : 0
                      }
                      onChange={onChange}
                      id="sucursal"
                      name="sucursal"
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Nombre/Razón Social:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtNombrePro}
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      name="nombre"
                      value={values.nombre && values.nombre}
                      onChange={onChange}
                      id="inputPropiet"
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Dirección:
                    </label>
                    <textarea
                      type="text"
                      autoComplete="off"
                      className="form-control uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtDireccionPro}
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      name="direccion"
                      value={values.direccion && values.direccion}
                      onChange={onChange}
                      id="inputDirecpropiet"
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Teléfono:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      maxLength="12"
                      ref={txtNumPro}
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      name="telefono"
                      value={values.telefono}
                      onChange={handleInputNumChange}
                      id="inputTelefonopropie"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-7">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      E-mail:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control uppercase"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      aria-label="Sizing example input"
                      ref={txtEmail}
                      aria-describedby="inputGroup-sizing-sm"
                      value={values.email && values.email.trim()}
                      onChange={onChange}
                      id="inputEmail"
                      name="email"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Municipio:
                    </label>
                    <select
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtMunicipio}
                      autoComplete="off"
                      className="form-select form-select-sm"
                      id="inputStatus"
                      name="municipio"
                      onChange={onChange}
                      value={
                        values.municipio !== null ? values.municipio.trim() : ""
                      }
                    >
                      <option value="">Seleccione</option>
                      {municipios &&
                        municipios.map((item, index) => (
                          <option key={index} value={item.idmunicipio}>
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Ciudad:
                    </label>
                    <select
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtCiudad}
                      autoComplete="off"
                      className="form-select form-select-sm"
                      id="inputStatus"
                      name="ciudad"
                      onChange={onChange}
                      value={values.ciudad !== null ? values.ciudad.trim() : ""}
                    >
                      <option value="">Seleccione</option>
                      {ciudades &&
                        ciudades.map((item, index) => (
                          <option key={index} value={item.idciudad}>
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className=" col-md-6 row py-3 px-4 justify-content-between ">
                  <div className="col-sm-11 p-0 text-success2">
                    <h4 className="text-success2  titulos">
                      <i className="fas fa-lg px-2 fa-user-edit"></i>Datos del
                      Representante Legal
                    </h4>
                    <hr />
                  </div>

                  <div className="input-group mx-auto py-1 row input-group-sm col-sm-6">
                    <label
                      className="col-sm-3 input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Cédula:
                    </label>
                    <select
                      ref={cmbNacionalidad}
                      defaultValue={
                        props.represent && props.represent.nacionalidad !== null
                          ? props.represent.nacionalidad.toString()
                          : ""
                      }
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      className="col-sm-3 px-1 form-select form-select-sm"
                    >
                      <option value="">-</option>
                      <option key="0" value="V">
                        V
                      </option>
                      <option key="1" value="E">
                        E
                      </option>
                    </select>
                    <input
                      type="text"
                      className="form-control form-control-sm px-1"
                      defaultValue={
                        props.represent
                          ? props.represent.cedula !== null
                            ? props.represent.cedula.trim()
                            : ""
                          : ""
                      }
                      placeholder="123456789"
                      ref={txtCedula}
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      maxLength="10"
                      name="cedularespo"
                      onChange={onChange}
                      onKeyUp={validarPersona}
                      onBlur={validarPersona}
                      id="inputCedrespon"
                    />
                    <button
                      className="btn btn-sm col-sm-2  btn-info "
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onClick={handleCatalogo}
                    >
                      <i className="fa fa-search"></i>{" "}
                    </button>
                  </div>

                  <div className="col-sm-2"></div>

                  <div className="input-group py-1 input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Sexo:
                    </label>
                    <select
                      disabled={
                        !habilitadoNU || operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      defaultValue={
                        props.represent && props.represent.sexo.toString()
                      }
                      ref={cmbSex}
                      className=" form-select form-select-sm"
                      id="inputLetraRif"
                    >
                      <option value="">-</option>
                      <option key="0" value="M">
                        M
                      </option>
                      <option key="1" value="F">
                        F
                      </option>
                    </select>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Nombres:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control uppercase"
                      defaultValue={
                        props.represent
                          ? props.represent.nombres !== null
                            ? props.represent.nombres.trim()
                            : ""
                          : ""
                      }
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtNombreRespon}
                      disabled={
                        !habilitadoNU || operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      name="nombres"
                      onChange={onChange}
                      id="inputNombrerespon"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Apellidos:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control uppercase"
                      disabled={
                        !habilitadoNU || operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      defaultValue={
                        props.represent
                          ? props.represent.apellidos !== null
                            ? props.represent.apellidos.trim()
                            : ""
                          : ""
                      }
                      aria-label="Sizing example input"
                      ref={txtApeRespon}
                      aria-describedby="inputGroup-sizing-sm"
                      name="apellidosp"
                      id="inputApellidos"
                      onChange={onChange}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Dirección:
                    </label>
                    <textarea
                      type="text"
                      autoComplete="off"
                      className="form-control uppercase"
                      aria-label="Sizing example input"
                      defaultValue={
                        props.represent
                          ? props.represent.direccion !== null
                            ? props.represent.direccion.trim()
                            : ""
                          : ""
                      }
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtDireccionRespon}
                      disabled={
                        !habilitadoNU || operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      name="direccionrespo"
                      onChange={onChange}
                      id="inputDireccionrespon"
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      E-mail:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control uppercase"
                      disabled={
                        !habilitadoNU || operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      aria-label="Sizing example input"
                      ref={txtEmailr}
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.represent
                          ? props.represent.correoe !== null
                            ? props.represent.correoe.trim()
                            : ""
                          : ""
                      }
                      name="correoe"
                      id="inputEmail"
                      onChange={onChange}
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Fecha Nacimiento:
                    </label>
                    <input
                      type="date"
                      autoComplete="off"
                      className="form-control"
                      disabled={
                        !habilitadoNU || operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      max={moment(fechas).format("YYYY-MM-DD")}
                      ref={txtFechNac}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.represent
                          ? props.represent.fnacimiento !== null
                            ? moment(props.represent.fnacimiento).format(
                                "YYYY-MM-DD"
                              )
                            : ""
                          : ""
                      }
                      id="inputFnac"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Teléfono:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      disabled={
                        !habilitadoNU || operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      aria-label="Sizing example input"
                      ref={txtTlf1}
                      aria-describedby="inputGroup-sizing-sm"
                      maxLength="12"
                      defaultValue={
                        props.represent
                          ? props.represent.tlf1 !== null
                            ? props.represent.tlf1
                            : ""
                          : ""
                      }
                      onChange={handleInputNumChange}
                      id="inputTelefrespon"
                      name="tlf1"
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Celular:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      disabled={
                        !habilitadoNU || operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      aria-label="Sizing example input"
                      ref={txtTlf2}
                      maxLength="12"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.represent
                          ? props.represent.tlf2 !== null
                            ? props.represent.tlf2
                            : ""
                          : ""
                      }
                      id="inputCel"
                      name="tlf2"
                    />
                  </div>
                </div>

                <hr className="col-sm-11 py-0 px-2 mx-auto container text-success2" />

                <div className="col-sm-12 row p-1">
                  <div className="row">
                    <div className="col-sm-2">
                      <h4 className="text-success2 titulos">
                        <i className="fas fa-lg px-1 fa-user-edit"></i> Datos
                        Tributarios{" "}
                      </h4>
                    </div>
                    <div className="form-check col-sm-2 form-check-inline">
                      <input
                        className="form-check-input rounded rounded-circle"
                        type="checkbox"
                        id="conveniofiscal"
                        name="conveniofiscal"
                        disabled={
                          operacion === 4 || operacion === 3 ? true : false
                        }
                        ref={chkConvenio}
                        onChange={onChange}
                        defaultChecked={
                          props.expendedor &&
                          props.expendedor.conveniofiscal === true
                            ? true
                            : false
                        }
                      />
                      <label
                        className="form-check-label "
                        htmlFor="flexCheckChecked7"
                      >
                        ¿Convenio?
                      </label>
                    </div>
                  </div>
                  <div className="col-sm-3 py-2 row align-items-end">
                    <div className="input-group input-group-sm col-sm-12 ">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nº de Resolución:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control uppercase"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={txtResolucion}
                        name="nroresolucionfiscal"
                        defaultValue={values.nroresolucionfiscal}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-3 py-2 row align-items-end">
                    <div className="input-group input-group-sm col-sm-12 ">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nº de Licencia:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control uppercase"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={txtLicencia}
                        name="nrolicenciafiscal"
                        defaultValue={values.nrolicenciafiscal}
                        onChange={onChange}
                        id="nrolicenciafiscal"
                      />
                    </div>
                  </div>

                  <div className="col-sm-3 row align-items-end">
                    <div className="input-group input-group-sm py-2 col-sm-12">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Crédito Bs:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control text-right"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        maxLength="10"
                        name="credito"
                        id="credito"
                        ref={txtMonto}
                        onFocus={seleccionarCampo}
                        defaultValue={
                          values && values.credito
                            ? formatMoneda(
                                values.credito
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            : ""
                        }
                        onBlur={handleInputMontoChange}
                        onKeyUp={handleInputMontoChange}
                      />
                    </div>
                  </div>

                  <fieldset className=" row col-sm-3 mx-auto border rounded">
                    <legend
                      className="float-none w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Exonerar
                    </legend>

                    <div className="form-check col form-check-inline">
                      <input
                        className="form-check-input rounded-circle"
                        type="checkbox"
                        id="flexCheckChecked0"
                        name="exoninteresesfiscal"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={chkIn}
                        onChange={onChange}
                        defaultChecked={
                          props.expendedor &&
                          props.expendedor.exoninteresesfiscal === true
                            ? true
                            : false
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckChecked0"
                      >
                        Interés
                      </label>
                    </div>

                    <div className="form-check col form-check-inline">
                      <input
                        className="form-check-input rounded-circle"
                        type="checkbox"
                        id="flexCheckChecked1"
                        name="exonmultasfiscal"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={chkIn1}
                        onChange={onChange}
                        defaultChecked={
                          props.expendedor &&
                          props.expendedor.exonmultasfiscal === true
                            ? true
                            : false
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckChecked1"
                      >
                        Multas
                      </label>
                    </div>

                    <div className="form-check col form-check-inline">
                      <input
                        className="form-check-input rounded-circle"
                        type="checkbox"
                        id="flexCheckChecked2"
                        name="exonrecargosfiscal"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={chkIn2}
                        onChange={onChange}
                        defaultChecked={
                          props.expendedor &&
                          props.expendedor.exonrecargosfiscal === true
                            ? true
                            : false
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckChecked2"
                      >
                        Recargos
                      </label>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer /* style={{ backgroundColor: "rgb()" }} */>
        <button
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/fiscales/modalFIscales.js